import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/data/site";

const STATS = [
  { value: "Roma", label: "La nostra base operativa" },
  { value: "ENAC/EASA", label: "Operazioni autorizzate" },
  { value: "2000+", label: "Clienti innovativi" },
];

export function About() {
  return (
    <section id="chi-siamo" className="py-24 sm:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div className="relative rounded-[2rem] overflow-hidden border border-white/10" data-testid="about-image-frame">
            <img src={IMAGES.about} alt="Casa con pannelli solari" className="w-full h-[420px] sm:h-[500px] object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050507]/60 to-transparent" />
          </div>
        </Reveal>

        <div>
          <Reveal>
            <p className="font-mono-adj text-xs uppercase tracking-[0.3em] text-orange-500 font-semibold">Chi Siamo</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white mt-4 leading-[1.05]">
              Innovazione al servizio <span className="fire-text">del tuo sole</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="text-base sm:text-lg text-slate-400 leading-relaxed mt-6">
              Fondata a Roma, AirDroneJet unisce l'ingegneria aeronautica dei droni con la
              sostenibilità dell'energia solare. Siamo autorizzati ENAC/EASA per operazioni
              urbane e residenziali in totale sicurezza, e portiamo la manutenzione del tuo
              impianto direttamente nel futuro.
            </p>
          </Reveal>
          <div className="grid grid-cols-3 gap-4 mt-10">
            {STATS.map((s, i) => (
              <Reveal key={s.label} delay={0.2 + i * 0.08}>
                <div className="border-t-2 border-orange-500/60 pt-4" data-testid={`about-stat-${i}`}>
                  <p className="font-display font-bold text-2xl sm:text-3xl text-white">{s.value}</p>
                  <p className="font-mono-adj text-[10px] uppercase tracking-[0.15em] text-slate-500 mt-2">{s.label}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
